import { jsx } from 'react/jsx-runtime';

const TriangleSvg = ({
  fill,
  className
}) => jsx("svg", Object.assign({
  "aria-hidden": "true",
  className: className,
  focusable: "false",
  preserveAspectRatio: "xMidYMid meet",
  tabIndex: -1,
  version: "1.1",
  viewBox: "0 0 64 32",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: jsx("polygon", {
    fill: fill,
    points: "0 0 32 32 64 0"
  }, void 0)
}), void 0);
TriangleSvg.displayName = 'TriangleSvg';

export { TriangleSvg };
